import React from "react";
import {
  withStyles,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  FormLabel,
  FormHelperText,
} from "@material-ui/core";
import WithRowLabel from "./PickupComponents/WithRowLabel";

const styles = (theme) => ({
  radioGroupLabel: {
    paddingTop: 8,
    paddingBottom: 8,
    fontSize: theme.dispatchCardTextFontSize,
    fontWeight: 500,
    color: theme.popupLeftColColor
  },
  radioLabelText: {
    fontSize: theme.headerTextFontSize,
    fontWeight: 400,
    color: theme.radioLabelText
  },
  radioLabel: {
    paddingRight: 32,
    marginBottom: 6,
    backgroundColor: theme.radioLabel,
    marginLeft: 0,
    marginRight: 8,
    borderRadius: 32
  },
  activeRadio: {
    backgroundColor: theme.activeRadioBG
  },
  selectedRadioLabelText: {
    color: theme.selectedRadioLabelText
  },
  radioIcon: {
    color: theme.radioIconColor
  },
  disabled: {
    backgroundColor: theme.trailerCardSelectedColor,
    '&$disabledLabel': {}
  },
  disabledLabel: {
    color: `${theme.chatMetadataColor}`
  }
});

const CustomRadioGroup = ({
  classes,
  headerLabel,
  options,
  helperText,
  error,
  onChange,
  value,
  customClasses
}) => {
  const handleChange = (event) => {
    onChange?.(event.target.value);
  };

  return (
    <FormControl component="fieldset" error={error}>
      <FormLabel
        component="legend"
        classes={{
          root: classes.radioGroupLabel
        }}
        focused>
        {headerLabel}
      </FormLabel>
      <RadioGroup row aria-label="position" value={value} onChange={handleChange}>
        {options.map((option) => {
          const isValueSelected = option.value === value;
          return (
            <FormControlLabel
              key={`dynamicRadioGrp_${option.value}`}
              classes={{
                root: `${classes.radioLabel} ${isValueSelected ? classes.activeRadio : ''}`,
                label: `${classes.radioLabelText} ${
                  isValueSelected ? classes.selectedRadioLabelText : ''
                } ${option.isDisabled ? classes.disabledLabel : ''}`,
                disabled: classes.disabled
              }}
              value={option.value}
              control={
                <Radio
                  color="primary"
                  className={isValueSelected ? '' : classes.radioIcon}
                  classes={{ disabled: classes.disabledLabel }}
                  disabled={option.isDisabled}
                />
              }
              label={option.labelText}
              disabled={option.isDisabled}
              customClasses={customClasses}
            />
          );
        })}
      </RadioGroup>
      {error && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

const StyledRadioGroup = withStyles(styles)(CustomRadioGroup);
const RadioGroupWithLabel = WithRowLabel(StyledRadioGroup);
export { StyledRadioGroup, RadioGroupWithLabel };
